import React from 'react';
import '../../css/PreviewPDF.css';
import { Client, TripInfo, ItineraryItem } from '../../types/Quotation';
import PDFPage1 from './PDFPage1';
import PDFPage2 from './PDFPage2';
import PDFPage3 from './PDFPage3';
import PDFPage4 from './PDFPage4';

interface PreviewPDFProps {
  client: Client;
  tripInfo: TripInfo;
  itinerary: ItineraryItem[];
  generalRules: string;
  highlights: string;
  highlightImages: string[];
  inclusionImages: string[];
  itineraryImages: string[];
}

const PreviewPDF: React.FC<PreviewPDFProps> = ({
  client,
  tripInfo,
  itinerary,
  highlights,
  highlightImages,
  inclusionImages,
  itineraryImages,
}) => (
  <div className="preview-pdf">
    <PDFPage1 client={client} tripInfo={tripInfo} itinerary={itinerary} highlights={highlights}/>
    <PDFPage2 highlightImages={highlightImages} inclusionImages={inclusionImages} itinerary={itinerary}/>
    <PDFPage3 itinerary={itinerary} itineraryImages={itineraryImages} startDate={tripInfo.startDate}/>
    <PDFPage4 />
  </div>
);

export default PreviewPDF;